<div>
  <form [formGroup]="socialMediaForm">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.facebook">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="facebook" />
            <label class="required" for="facebook">Facebook</label>
          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.instagram">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="instagram" />
            <label class="required" for="instagram">Instagram</label>

          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.threads">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="threads" />
            <label class="required" for="threads">Threads</label>
          </div>
        </form-helper>
      </div>

      <!--
        Redes desativadas no cadastro: o cadastro passou a coletar apenas
        Facebook, Instagram e Threads. As colunas seguem no banco com os dados
        ja gravados. Para reativar, descomentar o bloco abaixo e os controles
        correspondentes em company-setup.service.ts (socialMediaForm).

      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.whatsapp">
          <div class="material-textfield">
            <input mask="(00) 00000-0000" class="form-input" placeholder=" " formControlName="whatsapp" />
            <label class="required" for="whatsapp">Whatsapp</label>

          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.linkedin">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="linkedin" />
            <label class="required" for="linkedin">Linkedin</label>

          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.twitter">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="twitter" />
            <label class="required" for="twitter">Twitter</label>

          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.site">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="site" />
            <label class="required" for="site">Site</label>

          </div>
        </form-helper>
      </div>
      -->
    </div>
  </form>
</div>
